import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import Header from './Header';
import Navbar from './Navbar';

const CommonLayout = () => {
  return (
    <Container className="layout-container">
      <HeaderWrapper>
        <Header />
      </HeaderWrapper>
      <ContentWrapper>
        <Navbar />
        <MainContent>
          <Outlet />
        </MainContent>
      </ContentWrapper>
    </Container>
  );
};

export default CommonLayout;

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
`;

const HeaderWrapper = styled.header`
  flex-shrink: 0;
`;

const ContentWrapper = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
  min-height: 0;
`;

const MainContent = styled.main`
  flex: 1;
  padding: 32px;
  overflow-y: auto;
  background: #f3f4f6;
`;
